import { ValueRegistryItem } from '../ValueRegistryItem';
import { ValueRegistryCategory } from '../ValueRegistryCategory';
export class ValueRegistryActor extends ValueRegistryCategory {
    label = 'Actor';
    constructor(parent) {
        super(parent);
        super.init();
    }
    actorTextBasis = () => new ValueRegistryItem({
        value: ({ actor }) => {
            return (actor.global.activeOf.text && actor.global.activeOf.text.textBasis) || '';
        },
    });
    aspectToMeasure(app, at) {
        const actor = app.stage.stageActors.actorsRenderedOnStage.find(actor => actor.tags.includes(at.trait.local.valueOf.actorRoleName));
        if (at.trait.local.valueOf.aspectName)
            return actor.ownAspect[at.trait.local.valueOf.aspectName];
        return actor.actorMounted.outermostRenderedAspect;
    }
    actorHeight = () => new ValueRegistryItem({
        label: 'Measured Height of Actor',
        value: ({ app, at }) => {
            try {
                return this.aspectToMeasure(app, at).aspectMount.mountDimensions.aspectHeightInUnits;
            }
            catch (e) {
                return 20;
            }
        },
        params: { core: ['actorRoleName', 'aspectName'] },
    });
    actorWidth = () => new ValueRegistryItem({
        label: 'Measured Width of Actor',
        value: ({ app, at }) => {
            try {
                return this.aspectToMeasure(app, at).aspectMount.mountDimensions.aspectWidthInUnits;
            }
            catch (e) {
                return 20;
            }
        },
        params: { core: ['actorRoleName', 'aspectName'] },
    });
    actorLeft = () => new ValueRegistryItem({
        label: 'Measured left of Actor',
        value: ({ app, at }) => {
            try {
                return this.aspectToMeasure(app, at).aspectMount.measureToInnerStageIncludingTransform.aspectLeftInUnits;
            }
            catch (e) {
                return 20;
            }
        },
        params: { core: ['actorRoleName', 'aspectName'] },
    });
    actorTop = () => new ValueRegistryItem({
        label: 'Measured Top of Actor',
        value: ({ app, at }) => {
            try {
                return this.aspectToMeasure(app, at).aspectMount.measureToInnerStageIncludingTransform.aspectTopInUnits;
            }
            catch (e) {
                return 20;
            }
        },
        params: { core: ['actorRoleName', 'aspectName'] },
    });
}
